import { chronological } from "./source";
import { loadLanguageOL } from "./translations";

const myModal = new bootstrap.Modal(document.getElementById('exampleModal'));
//myModal.show();

export function info(lang) {

    $.get('./assets/lang/info_' + lang + '.html', function (data) {
        $('.modal-content').html(data)
    })

}

info('en');
myModal.show();

function closeOpenPanel(closeBtn, closeItem, openItem) {
    $(closeBtn).on('click', function (e) {
        $(closeItem).css('display', 'none')
        $(openItem).css('display', 'block')
    });
}
closeOpenPanel('#closeDatapanel', '#datapanel', '#datapanelicon');
closeOpenPanel('#datapanelicon', '#datapanelicon', '#datapanel')

closeOpenPanel('#closelegendFilters', '#legendFilters', '#legendfiltersicon');
closeOpenPanel('#legendfiltersicon', '#legendfiltersicon', '#legendFilters')



function checkPosition() {
    if (window.matchMedia('(max-width: 767px)').matches) {
        $('#legendFilters').css('display', 'none')
        $('#legendfiltersicon').css('display', 'block')
    }
}

checkPosition()

//tooltip

$('#filterYear .form-check-label').attr('data-bs-toggle', "tooltip");
$('#filterYear .form-check-label').attr('data-bs-original-title', 'Show travel direction and filter by year');

var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl, {
        customClass: 'custom-tooltip',
        animated: 'fade',
        placement: 'bottom',
        trigger: 'hover'
    })
})

export var toggleTravels = $('input[data-toggle="toggle"]').bootstrapToggle({
    onlabel: loadLanguageOL('en', 'travelsLabel'),
    offlabel: loadLanguageOL('en', 'travelsLabel'),
    size: "sm"
});

$('#switchCheckReverse').on("change", function () {
    if (this.checked) {
        chronological.setVisible(true)
        $(".year").removeAttr('disabled');
        toggleTravels.bootstrapToggle("off")
    }
    else {
        chronological.setVisible(false);
        $(".year").prop("disabled", true);
        toggleTravels.bootstrapToggle("on")

    }
})

$(document).on('click', function () {
    $("div").remove(".tooltip");
});
